import useSWR from "swr";
import { fetcher } from "lib/actions/fetcher";
import { endpointsViews } from "lib/actions/endpoints/endpointsViews";
import { mapViewFromResponse } from "lib/actions/views/mapViewFromResponse";
import { useMemo } from "react";
import { useAssets } from "./assets/useAssets";
import { ViewResponseModel } from "lib/types/views/ViewResponseModel";
import { AssetVersionWithAssetModel } from "lib/types/assets/AssetVersionWithAssetModel";

export function useProjectView(projectId: number, viewId: number) {
  const {
    data: view,
    isLoading: isViewLoading,
    error: viewError,
  } = useSWR(viewId && endpointsViews.viewById(viewId), (url) =>
    fetcher<ViewResponseModel>(url).then(mapViewFromResponse),
  );

  const {
    versions,
    isLoading: isVersionsLoading,
    hasError: hasVersionsError,
  } = useAssets(projectId);

  const assetVersions = useMemo((): AssetVersionWithAssetModel[] => {
    if (!view || !versions) return [];
    const viewVersionIds = new Set(view.assetVersionIds);
    return versions.filter((v) => viewVersionIds.has(v.id));
  }, [versions, view]);

  const isLoading = (!view && isViewLoading) || isVersionsLoading;
  const hasError = !projectId || !viewId || !!viewError || hasVersionsError;

  return {
    view,
    assetVersions,
    isLoading,
    hasError,
  };
}
